import axios from 'axios';
import serverConfig from './config';

import moment from 'moment';

const formdata_config = {
	headers: {
		'content-type': 'multipart/form-data',
	},
};

const post_config = {
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
	},
};

class Server {
	constructor() {
		this.path = serverConfig.path;
		this.port = serverConfig.port;
	}

	sendProfilePicture = (uid, formData) => {
		return axios.post(
			`${this.path}:${this.port}/user/img/${uid}`,
			formData,
			formdata_config
		);
	};

	sendTermsData = (uid) => {
		const params = new URLSearchParams();
		params.append('date', moment().format('YYYY-MM-DD HH:mm:ss'));
		params.append('timestamp', moment().unix());

		return axios.post(
			`${this.path}:${this.port}/user/${uid}/set-terms-data`,
			params,
			post_config
		);
	};

	sendEventAsset = (event_id, panel, formData) => {
		return axios.post(
			`${this.path}:${this.port}/event/assets/${event_id}/${panel}`,
			formData,
			formdata_config
		);
	};

	sendEventPicture = (event_id, type, formData) => {
		return axios.post(
			`${this.path}:${this.port}/event/image/${event_id}/${type}`,
			formData,
			formdata_config
		);
	};

	sendGlobalPicture = (formData) => {
		return axios.post(
			`${this.path}:${this.port}/global/image`,
			formData,
			formdata_config
		);
	};

	sendEventProfileIcon = (event_id, user_id, formData) => {
		return axios.post(
			`${this.path}:${this.port}/event/${event_id}/user/${user_id}`,
			formData,
			formdata_config
		);
	};

	events = {
		create: (serverId, name, url, transcoder, delivery_type, event_name) => {
			const params = new URLSearchParams();
			params.append('serverId', serverId);
			if (transcoder) params.append('transcoder', transcoder);
			if (delivery_type) params.append('delivery_type', delivery_type);
			if (url) params.append('url', url);
			//if (event_name) params.append('event_name', event_name);

			return axios.post(
				`${this.path}:${this.port}/event/new/${name}`,
				params,
				post_config
			);
		},
		streamControl: (serverId, name, command, id) => {
			const params = new URLSearchParams();

			params.append('serverId', serverId);
			params.append('applicationId', id);

			return axios.post(
				`${this.path}:${this.port}/event/control/${name}/${command}`,
				params,
				post_config
			);
		},
		getStatus: (serverId, name, event_id) => {
			const params = new URLSearchParams();

			return axios.get(
				`${this.path}:${this.port}/event/status/${serverId}/${name}/${event_id}`,
				params,
				post_config
			);
		},
		rejectUser: (
			event_id,
			event_name,
			event_url,
			user_email,
			user_name,
			hasCustomBrand,
			uid,
			eventCustomLogo
		) => {
			const params = new URLSearchParams();
			params.append('eventName', event_name);
			params.append('eventUrl', event_url);
			params.append('userEmail', user_email);
			params.append('userName', user_name);

			params.append('hasCustomBrand', hasCustomBrand);
			params.append('eventCustomLogo', eventCustomLogo);

			params.append('uid', uid);

			return axios.post(
				`${this.path}:${this.port}/event/subscribers/${event_id}/send/rejected`,
				params,
				post_config
			);
		},
		approveUser: (
			event_id,
			event_name,
			event_url,
			event_start_date,
			event_gmt,
			user_email,
			user_name,
			hasCustomBrand,
			uid,
			eventCustomLogo,
			password,
			code,
			hasAccessCode,
			onlyCode
		) => {
			const params = new URLSearchParams();
			params.append('eventName', event_name);
			params.append('eventUrl', event_url);
			params.append('eventStartDate', event_start_date);
			params.append('eventGMT', event_gmt);
			params.append('userEmail', user_email);
			params.append('userName', user_name);
			params.append('code', code);

			params.append('hasCustomBrand', hasCustomBrand);
			params.append('eventCustomLogo', eventCustomLogo);

			params.append('uid', uid);
			params.append('password', password);
			params.append('hasAccessCode', hasAccessCode);
			params.append('onlyCode', onlyCode);

			return axios.post(
				`${this.path}:${this.port}/event/subscribers/${event_id}/send/approved`,
				params,
				post_config
			);
		},
		getStatistics: (event_id, process) => {
			const params = new URLSearchParams();
			return axios.post(
				`${this.path}:${this.port}/event/statistics/${event_id}/${process}`,
				params,
				post_config
			);
		},
		getRecording: (serverId, event_id, webrtc_id = false) => {
			const params = new URLSearchParams();

			params.append('serverId', serverId);
			params.append('webrtcId', webrtc_id || 'none');

			return axios.post(
				`${this.path}:${this.port}/event/recording_status/${event_id}`,
				params,
				post_config
			);
		},
		deleteFiles: (serverId, event_id, stream_id) => {
			const params = new URLSearchParams();
			params.append('serverId', serverId);
			params.append('streamId', stream_id);

			return axios.post(
				`${this.path}:${this.port}/event/delete/${event_id}`,
				params,
				post_config
			).then(response => response.data);
		},
		getStreamTargets: (serverId, application) => {
			const params = new URLSearchParams();
			params.append('serverId', serverId);

			return axios.post(
				`${this.path}:${this.port}/event/${application}/stream-targets`,
				params,
				post_config
			);
		},

		getStreamTargetsStatus: (serverId, application, eventId) => {
			const params = new URLSearchParams();
			params.append('serverId', serverId);
			params.append('eventId', eventId);

			return axios.post(
				`${this.path}:${this.port}/event/${application}/stream-targets-status`,
				params,
				post_config
			);
		},

		streamTargetTurnStatus: (
			serverId,
			application,
			stream_target_id,
			action,
			transcoderId
		) => {
			const params = new URLSearchParams();
			params.append('serverId', serverId);
			params.append('stream_target_id', stream_target_id);
			params.append('action', action);
			params.append('transcoderId', transcoderId);

			return axios.post(
				`${this.path}:${this.port}/event/${application}/stream-target-turn-status`,
				params,
				post_config
			);
		},
		deleteRecording: (serverId, event_id, fileName, videoId) => {
			const params = new URLSearchParams();
			params.append('serverId', serverId);
			params.append('fileName', fileName);
			params.append('videoId', videoId);

			return axios.post(
				`${this.path}:${this.port}/event/delete_recording/${event_id}`,
				params,
				post_config
			);
		},
		regenerateConnectionCode: (serverId, application, transcoder) => {
			const params = new URLSearchParams();

			params.append('serverId', serverId);
			params.append('transcoder', transcoder);

			return axios.post(
				`${this.path}:${this.port}/event/${application}/regenerate-connection-code`,
				params,
				post_config
			);
		},
		setEncoder: (serverId, stream_id, name, webrtc_id, encoder) => {
			const params = new URLSearchParams();

			params.append('serverId', serverId);
			params.append('encoder', encoder);
			params.append('name', name);
			params.append('webrtc', webrtc_id || 'none');

			return axios.post(
				`${this.path}:${this.port}/event/${stream_id}/change-encoder`,
				params,
				post_config
			);
		},
		getUsage: (serverId, stream_id) => {
			const params = new URLSearchParams();

			return axios.get(
				`${this.path}:${this.port}/event/usage/${serverId}/${stream_id}`,
				params,
				post_config
			);
		},
		updatePlayer: (id) => {
			const params = new URLSearchParams();

			return axios.get(
				`${this.path}:${this.port}/admin/players/${id}/update`,
				params,
				post_config
			);
		},
		getSource: (id) => {
			const params = new URLSearchParams();

			return axios.get(
				`${this.path}:${this.port}/event/${id}/get-url`,
				params,
				post_config
			);
		},
		getStreamStatus: (serverId, stream_id, event_id) => {
			const params = new URLSearchParams();

			return axios.get(
				`${this.path}:${this.port}/event/stream_status/${serverId}/${stream_id}/${event_id}`,
				params,
				post_config
			);
		},
	};

	users = {
		get: () => {
			const params = new URLSearchParams();
			return axios.post(
				`${this.path}:${this.port}/users/list`,
				params,
				post_config
			);
		},
		getPaginated: ({ page = 1, limit = 25, search = '', filter = 'users' }) => {
			const params = new URLSearchParams();
			params.append('page', page);
			params.append('limit', limit);
			params.append('search', search);
			params.append('filter', filter);
			return axios.post(
				`${this.path}:${this.port}/users/list/paginated`,
				params,
				post_config
			);
		},
		delete: (id) => {
			const params = new URLSearchParams();
			return axios.post(
				`${this.path}:${this.port}/users/${id}/delete`,
				params,
				post_config
			);
		},
	};

	createSubscriber = (data, event) => {
		const params = new URLSearchParams();

		for (var index in data) {
			params.append(index, data[index]);
		}

		params.append('event_id', event.id);
		params.append('event_name', event.name);
		params.append('event_url', event.url);
		params.append('event_start_data', event.startDate);
		params.append('event_gmt', event.gmt);
		params.append('event_custom_logo', event.eventCustomBrand);

		params.append('hasCustomBrand', event.hasCustomBrand);
		params.append('uid', event.uid);

		params.append('hasAccessCode', event.hasAccessCode);
		params.append('onlyCode', event.onlyCode);

		return axios.post(
			`${this.path}:${this.port}/users/create-subscriber`,
			params,
			post_config
		);
	};

	sendConfirmationEmail = (data, event) => {
		const params = new URLSearchParams();

		for (var index in data) {
			params.append(index, data[index]);
		}

		params.append('event_id', event.id);
		params.append('event_name', event.name);
		params.append('event_url', event.url);
		params.append('event_start_data', event.startDate);
		params.append('event_gmt', event.gmt);

		params.append('hasCustomBrand', event.hasCustomBrand);
		params.append('eventCustomLogo', event.eventCustomBrand);
		params.append('hasAccessCode', event.hasAccessCode);
		params.append('onlyCode', event.onlyCode);
		params.append('uid', event.uid);

		return axios.post(
			`${this.path}:${this.port}/users/send-confirmation-email`,
			params,
			post_config
		);
	};

	testMysqlConnection = (data) => {
		const params = new URLSearchParams();

		params.append('host', data.host);
		params.append('user', data.user);
		params.append('password', data.password);
		params.append('port', data.port);
		params.append('database', data.database);

		return axios.post(
			`${this.path}:${this.port}/subscribers/mysql/test`,
			params,
			post_config
		);
	};

	saveMysqlConnection = (eventId, data) => {
		const params = new URLSearchParams();

		params.append('eventId', eventId);
		params.append('host', data.host);
		params.append('user', data.user);
		params.append('password', data.password);
		params.append('port', data.port);
		params.append('database', data.database);

		params.append('hasCustomBrand', data.hasCustomBrand);
		params.append('uid', data.uid);

		return axios.post(
			`${this.path}:${this.port}/subscribers/mysql/save`,
			params,
			post_config
		);
	};

	getMysqlConnectionData = (eventId) => {
		const params = new URLSearchParams();

		params.append('id', eventId);

		return axios.post(
			`${this.path}:${this.port}/subscribers/mysql/get`,
			params,
			post_config
		);
	};

	saveVideoServer = (name, data) => {
		const params = new URLSearchParams();
		params.append('id', name);
		for (var index in data) {
			params.append(index, data[index]);
		}

		return axios.post(
			`${this.path}:${this.port}/video-server/new`,
			params,
			post_config
		);
	};

	getVideoServers = () => {
		const params = new URLSearchParams();

		return axios.post(
			`${this.path}:${this.port}/video-server/all/get`,
			params,
			post_config
		);
	};

	getVideoServer = (id) => {
		const params = new URLSearchParams();

		params.append('id', id);

		return axios.post(
			`${this.path}:${this.port}/video-server/get`,
			params,
			post_config
		);
	};

	deleteVideoServer = (id) => {
		const params = new URLSearchParams();
		params.append('id', id);

		return axios.post(
			`${this.path}:${this.port}/video-server/delete`,
			params,
			post_config
		).then(response => response.data);
	};

	newStreamTarget = (serverId, transcoderId, data) => {
		const params = new URLSearchParams();
		for (var index in data) {
			params.append(index, data[index]);
		}

		params.append('serverId', serverId);

		return axios.post(
			`${this.path}:${this.port}/event/${transcoderId}/new-stream-target`,
			params,
			post_config
		);
	};

	deleteStreamTarget = (serverId, transcoderId, data) => {
		const params = new URLSearchParams();

		for (var index in data) {
			params.append(index, data[index]);
		}

		params.append('serverId', serverId);

		return axios.post(
			`${this.path}:${this.port}/event/${transcoderId}/delete-stream-target`,
			params,
			post_config
		);
	};

	editStreamTarget = (serverId, transcoderId, data) => {
		const params = new URLSearchParams();
		for (var index in data) {
			params.append(index, data[index]);
		}

		params.append('serverId', serverId);

		return axios.post(
			`${this.path}:${this.port}/event/${transcoderId}/edit-stream-target`,
			params,
			post_config
		);
	};

	signInWithToken = (data) => {
		const params = new URLSearchParams();
		for (var index in data) {
			params.append(index, data[index]);
		}

		return axios.post(
			`${this.path}:${this.port}/sign-in-with-token`,
			params,
			post_config
		);
	};

	signInWithTokenByEmail = (data) => {
		const params = new URLSearchParams();
		for (var index in data) {
			params.append(index, data[index]);
		}

		return axios.post(
			`${this.path}:${this.port}/sign-in-with-token-by-email`,
			params,
			post_config
		);
	};

	/**
	 * Admin methods
	 */
	admin = {
		getVideoServers: (uid) => {
			return axios.get(
				`${this.path}:${this.port}/admin/video-servers/list?uid=${uid}`
			);
		},

		getAllRecordings: (serverId, uid, forceRefresh = false, firebaseEnv = 'development', onlyActiveEvents = true) => {
			const params = new URLSearchParams();
			params.append('serverId', serverId);
			params.append('uid', uid);
			params.append('forceRefresh', forceRefresh);
			params.append('firebaseEnv', firebaseEnv);
			params.append('onlyActiveEvents', onlyActiveEvents);

			// Timeout corto, ahora solo inicia el proceso
			return axios.post(
				`${this.path}:${this.port}/admin/recordings/list`,
				params,
				{
					...post_config,
					timeout: 10000, // 10 segundos
				}
			);
		},

		getRecordingsStatus: (serverId, uid, firebaseEnv = 'development') => {
			return axios.get(
				`${this.path}:${this.port}/admin/recordings/status?serverId=${serverId}&uid=${uid}&firebaseEnv=${firebaseEnv}`
			);
		},

		stopRecordingsProcessing: (serverId, uid, firebaseEnv = 'development') => {
			const params = new URLSearchParams();
			params.append('serverId', serverId);
			params.append('uid', uid);
			params.append('firebaseEnv', firebaseEnv);

			return axios.post(
				`${this.path}:${this.port}/admin/recordings/stop`,
				params,
				post_config
			);
		},

		deleteRecordings: (recordings, serverId) => {
			// recordings es un array de objetos con { id, eventId }
			const promises = recordings.map((recording) => {
				const params = new URLSearchParams();
				params.append('serverId', serverId);
				params.append('videoId', recording.id);
				params.append('event_id', recording.eventId);

				return axios.post(
					`${this.path}:${this.port}/event/delete_recording/${recording.eventId}`,
					params,
					post_config
				);
			});

			return Promise.all(promises);
		},
	};
}

export default new Server();
